import React, { useEffect, useState } from "react";
import { FiEyeOff, FiLock, FiEye } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import app from "../axiosConfig";
import Loader from "../components/Loader";
import { addToastMsg } from "../redux/auth/authActions";

function ResetPassword() {
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordDisplay, setPasswordDisplay] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password === "" || confirmPassword === "")
      return dispatch(addToastMsg("Please fill both the fields", "error"));
    if (password !== confirmPassword) {
      return dispatch(addToastMsg("Passwords do not match", "error"));
    }
    try {
      const { data } = await app.post("/auth/reset-password", {
        password,
        id: params.id,
      });
      navigate("/login");
      dispatch(addToastMsg(data?.message, "success"));
    } catch (error) {
      dispatch(addToastMsg(error?.response?.data?.message, "error"));
    }
  };

  useEffect(() => {
    async function verifyToken() {
      try {
        await app.post("/auth/verify-token", {
          token: params.token,
          id: params.id,
        });
        setIsLoading(false);
      } catch (error) {
        navigate("/login");
        dispatch(addToastMsg(error?.response?.data?.message, "error"));
      }
    }
    verifyToken();
    // eslint-disable-next-line
  }, []);

  if (isLoading) return <Loader />;

  return (
    <div className="login-page-container">
      <img className="login-logo" src="/logo.svg" alt="" />

      <form className="login-form-container" onSubmit={(e) => handleSubmit(e)}>
        <div className="reset-password-heading">
          <h2>Create New Password</h2>
        </div>
        <input
          label="User ID"
          autoComplete="username"
          placeholder="User ID"
          hidden
          aria-hidden
        />
        <div className="login-input-container">
          <FiLock size={22} color="white" />
          <input
            className="login-input"
            label="Password"
            autoComplete="new-password"
            id="current-password"
            type={passwordDisplay ? "password" : "text"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {!passwordDisplay ? (
            <FiEyeOff
              size={22}
              color="white"
              onClick={() => setPasswordDisplay(!passwordDisplay)}
            />
          ) : (
            <FiEye
              size={22}
              color="white"
              onClick={() => setPasswordDisplay(!passwordDisplay)}
            />
          )}
        </div>
        <div className="login-input-container">
          <FiLock size={22} color="white" />
          <input
            className="login-input"
            label="Password"
            autoComplete="new-password"
            id="confirm-password"
            type={passwordDisplay ? "password" : "text"}
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        <div className="login-btn-container">
          <button type="submit" className="login-btn">
            Reset Password
          </button>
        </div>
      </form>
    </div>
  );
}

export default ResetPassword;
